function howToMeasureRev2() {
  // alert('test');
  let sizingContainer = document.querySelector('.bra-calc-v2__container');
  let bandSize = document.getElementById('bandSize');
  let bustSize = document.getElementById('bustSize');
  let sizeUS = document.getElementById('sizeUS');
  let sizeEU = document.getElementById('sizeEU');
  let sizeUK = document.getElementById('sizeUK');
  let sizeFR = document.getElementById('sizeFR');
  let sizeIT = document.getElementById('sizeIT');
  let sizeAU = document.getElementById('sizeAU');
  let resetBtn = document.getElementById('resetBtn');
  let radios = document.querySelectorAll('.radio-measurement');
  let submitForm = document.querySelector('.bra-calc-v2__form-wrap');
  let submitBtn = document.querySelector('.bra-calc-v2__btn');
  let boombaResult = document.querySelector('.bra-calc-v2__result-letter');
  let resultWrap = document.querySelector('.bra-calc-v2__result-wrap');
  let inputTxt = document.querySelectorAll('.bra-calc-v2__input-txt');

  if (sizingContainer) {
    let radioValue;
    radios.forEach((radio) => {
      radio.addEventListener('change', (event) => {
        reset();
        bandSize.value = '';
        bustSize.value = '';
        // Log the value of the selected radio button
        // console.log('radio value: ' + event.target.value);
        radioValue = event.target.value;

        if (radioValue === 'cm') {
          inputTxt.forEach((txt) => {
            txt.innerHTML = 'cm.';
            bandSize.setAttribute('min', 52);
            bandSize.setAttribute('max', 102);

            bustSize.setAttribute('max', 112);
          });
        }
        else {
          inputTxt.forEach((txt) => {
            txt.innerHTML = 'in.';
            bandSize.setAttribute('min', 21);
            bandSize.setAttribute('max', 40);
          });
        }
      });
    });


    const map1 = { "26": 16, "28": 16, "30": 15, "32": 14, "34": 13, "36": 12, "38": 11, "40": 10, "42": 9, "44": 8 };
    let newData;
    const cmData = {
      21: [52, 53, 54],
      22: [55, 56],
      23: [57, 58, 59],
      24: [60, 61],
      25: [62, 63, 64],
      26: [65, 66, 67],
      27: [68, 69],
      28: [70, 71, 72],
      29: [73, 74],
      30: [75, 76, 77],
      31: [78, 79, 80],
      32: [81, 82],
      33: [83, 84, 85],
      34: [86, 87],
      35: [88, 89, 90],
      36: [91, 92],
      37: [93, 94, 95],
      38: [96, 97],
      39: [98, 99, 100],
      40: [101, 102],
      41: [103, 104, 105],
      42: [106, 107],
      43: [108, 109, 110],
      44: [111, 112],
      45: [113, 114, 115],
      46: [116, 117, 118],
      47: [119, 120],
      48: [121, 122, 123],
      49: [124, 125],
      50: [126, 127, 128],
      51: [129, 130],
      52: [131, 132, 133]
    };


    let bandFoundKey = null;
    let bustFoundKey = null;

    bandSize.addEventListener('change', () => {
      let bandTargetValue = Math.round(Number(bandSize.value));
      // console.log('bandSize.value: ' + bandSize.value);
      // let bandFoundKey = null;

      // Loop through the cmData object
      for (let key in cmData) {
        if (cmData[key].includes(bandTargetValue)) {
          bandFoundKey = key;
          break; // Stop the loop once the value is found
        }
      }

      if (bandFoundKey) {
        // console.log(`The value ${bandTargetValue} is associated with the key: ${bandFoundKey}`);
        if (bandFoundKey % 2 !== 0) {
          newData = map1[Number(bandFoundKey) + 1];
        }
        else {
          newData = map1[Number(bandFoundKey) + 0];
        }


        let numericKey = Number(bandFoundKey);

        // console.log('numericKey: ' + numericKey);
        // console.log('newData: ' + newData);

        let sizeRow = cmData[(numericKey + newData) + 1];
        if (numericKey % 2 !== 0) {
          numericKeyVal = numericKey + 1;
        }
        else {
          numericKeyVal = numericKey + 0;
        }
        let sizeRow2 = cmData[numericKeyVal-5];
        // console.log("sizeRow: " + sizeRow);
        let maxSize = (sizeRow.length) - 1;

        bustSize.setAttribute('max', sizeRow[maxSize]);
        bustSize.setAttribute('min', sizeRow2[0]);

        // console.log('test pass: ' + sizeRow[maxSize]);
      } else {
        console.log(`The value ${bandTargetValue} is not found in the data.`);
      }
    });

    bustSize.addEventListener('change', () => {
      let bustTargetValue = Number(bustSize.value);

      // Loop through the cmData object
      for (let key in cmData) {
        if (cmData[key].includes(bustTargetValue)) {
          bustFoundKey = key;
          break;
        }
      }
    });




    resetBtn.addEventListener('click', () => {
      reset();
      resultWrap.classList.remove('active');
      bandSize.value = '';
      bustSize.value = '';
    });

    function reset() {
      sizeUS.innerHTML = '';
      sizeAU.innerHTML = '';
      sizeUK.innerHTML = '';
      sizeEU.innerHTML = '';
      sizeFR.innerHTML = '';
      sizeIT.innerHTML = '';
      boombaResult.innerHTML = '';
    }

    submitForm.addEventListener('submit', function (event) {
      event.preventDefault();
    });
    submitBtn.addEventListener('click', () => {
      reset();
      execute();
    });
    bandSize.addEventListener('change', () => {
      reset();
      execute();
    });
    bustSize.addEventListener('change', () => {
      reset();
      execute();
    });


    const boombaSize = ["AA", "AA", "AA", "AA", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M"];
    // const numSizesUS = ["28", "30", "32", "34", "36", "38", "40", "42", "44"];
    const letterSizesUS = ["AA", "A", "B", "C", "D", "DD/E", "DDD/F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P"];
    const letterSizesAU = ["AA", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P"];
    const letterSizesUK = ["AA", "A", "B", "C", "D", "DD", "E", "F", "FF", "G", "GG", "H", "HH", "J", "JJ", "K", "KK"];
    const letterSizesEU = ["AA", "A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "M", "N", "O", "P", "R"];
    const letterSizesFR = ["AA", "A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "M", "N", "O", "P", "R"];
    const letterSizesIT = ["AA", "A", "B", "C", "D", "DD", "E", "F", "FF", "G", "GG", "H", "HH", "J", "JJ", "K", "KK"];
    const dataMap1 = { "26": 16, "28": 16, "30": 15, "32": 14, "34": 13, "36": 12, "38": 11, "40": 10, "42": 9, "44": 8 };
    const dataMap2 = { "26": 0, "28": 1, "30": 2, "32": 3, "34": 4, "36": 5, "38": 6, "40": 7, "42": 8, "44": 9, };

    const braSizeData = {
      26: ["4", "26", "55", "70", "00"],
      28: ["6", "28", "60", "75", "00"],
      30: ["8", "30", "65", "80", "0"],
      32: ["10", "32", "70", "85", "1"],
      34: ["12", "34", "75", "90", "2"],
      36: ["14", "36", "80", "95", "3"],
      38: ["16", "38", "85", "100", "4"],
      40: ["18", "40", "90", "105", "5"],
      42: ["20", "42", "95", "110", "6"],
      44: ["22", "44", "100", "115", "7"]
    };


    function execute() {

      if (radioValue !== 'cm') {
        // alert('in');

        let bandSizeVal, bustSizeVal;

        if (Math.round(bandSize.value) % 2 !== 0) {
          bandSizeVal = Math.round(bandSize.value) + 1;
        }
        else {
          bandSizeVal = Math.round(bandSize.value) + 0;
        }
        if (bustSize.value % 2 !== 0) {
          bustSizeVal = parseInt(bustSize.value) + 1;
        }
        else {
          bustSizeVal = parseInt(bustSize.value) + 0;
        }

        let output = dataMap1[bandSizeVal];
        let sizeDiff = bustSize.value - bandSizeVal;


        bustSize.setAttribute('min', bandSizeVal - 5);
        bustSize.setAttribute('max', Number(bandSizeVal) + output);
        // console.log(output);

        if (bandSize.value !== "" && bustSize.value !== "") {

          if (sizeDiff <= 16) {
            // let minus1 = 0
            // if(sizeDiff >= 1) {
            //   minus1 = 1;
            // }

           console.log('round:' + Math.round(parseInt(bandSize.value)));


            if (sizeDiff < 1 && sizeDiff >= -5) {
              sizeDiff = 0;
            }

            newSizeDiff = Number(dataMap2[bandSizeVal]) + (sizeDiff - 1);
            // console.log('sizeDiff:' + sizeDiff);
            // console.log('newSizeDiff:' + newSizeDiff);
            // console.log('boombaSize:' + boombaSize[newSizeDiff]);
            // console.log('letterSizesUS:' + letterSizesUS[sizeDiff]);

            if (letterSizesUS[sizeDiff] !== undefined && boombaSize[newSizeDiff] !== undefined) {
              resultWrap.classList.add('active');
              sizeUS.innerHTML = bandSizeVal + letterSizesUS[sizeDiff];
              sizeAU.innerHTML = braSizeData[bandSizeVal][0] + letterSizesAU[sizeDiff];
              sizeUK.innerHTML = braSizeData[bandSizeVal][1] + letterSizesUK[sizeDiff];
              sizeEU.innerHTML = braSizeData[bandSizeVal][2] + letterSizesEU[sizeDiff];
              sizeFR.innerHTML = braSizeData[bandSizeVal][3] + letterSizesFR[sizeDiff];
              sizeIT.innerHTML = braSizeData[bandSizeVal][4] + letterSizesIT[sizeDiff];

              boombaResult.innerHTML = boombaSize[newSizeDiff];
              // console.log('pass test: ' + newSizeDiff);
            }
            else {
              reset();
            }
            // console.log("newSizeDiff: " + newSizeDiff);
          }
          else {
            reset();
          }
          // console.log("boomba size: " + boombaSize[newSizeDiff]);
          // console.log("band size: " + bandSizeVal);
          // console.log("bust size: " + bustSizeVal);
          // console.log("diff in letter: " + letterSizesUS[sizeDiff]);
          // console.log("diff in number: " + sizeDiff);

        }
      }
      else {
        // alert('cm');
        // bustSize.setAttribute('min', bandSize.value);

        let bandKeyVal = bandFoundKey;
        let bustKeyVal = bustFoundKey;

        // console.log('bandKeyVal: ' + bandKeyVal);
        // console.log('bustKeyVal: ' + bustKeyVal);

        let bandSizeVal, bustSizeVal;

        if (bandKeyVal % 2 !== 0) {
          bandSizeVal = parseInt(bandKeyVal) + 1;
        }
        else {
          bandSizeVal = parseInt(bandKeyVal) + 0;
        }
        if (bustKeyVal % 2 !== 0) {
          bustSizeVal = parseInt(bustKeyVal) + 1;
        }
        else {
          bustSizeVal = parseInt(bustKeyVal) + 0;
        }

        let sizeDiff = bustKeyVal - bandSizeVal;

        if (bandSize.value !== "" && bustSize.value !== "") {

          if (sizeDiff <= 16) {
            // let minus1 = 0
            // if(sizeDiff >= 1) {
            //   minus1 = 1;
            // }

          if (sizeDiff < 1 && sizeDiff >= -5) {
              sizeDiff = 0;
            }
            newSizeDiff = Number(dataMap2[bandSizeVal]) + (sizeDiff - 1);

            if (letterSizesUS[sizeDiff] !== undefined && boombaSize[newSizeDiff] !== undefined) {
              resultWrap.classList.add('active');
              sizeUS.innerHTML = bandSizeVal + letterSizesUS[sizeDiff];
              sizeAU.innerHTML = braSizeData[bandSizeVal][0] + letterSizesAU[sizeDiff];
              sizeUK.innerHTML = braSizeData[bandSizeVal][1] + letterSizesUK[sizeDiff];
              sizeEU.innerHTML = braSizeData[bandSizeVal][2] + letterSizesEU[sizeDiff];
              sizeFR.innerHTML = braSizeData[bandSizeVal][3] + letterSizesFR[sizeDiff];
              sizeIT.innerHTML = braSizeData[bandSizeVal][4] + letterSizesIT[sizeDiff];

              boombaResult.innerHTML = boombaSize[newSizeDiff];
              // console.log('pass test: ' + newSizeDiff);
            }
            else {
              reset();
            }
            // console.log("newSizeDiff: " + newSizeDiff);
          }
          else {
            reset();
          }
          // console.log("boomba size: " + boombaSize[newSizeDiff]);
          // console.log("band size: " + bandSizeVal);
          // console.log("bust size: " + bustSizeVal);
          // console.log("diff in letter: " + letterSizesUS[sizeDiff]);
          // console.log("diff in number: " + sizeDiff);

        }
      }
    }
  }
}
howToMeasureRev2();